import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../common_components/common_widgets/toast/notify";
import { getDefaultOptions } from "../../../utils/fetch";
export const DELETE_REF_TASK = "DELETE_REF_TASK";

export const service = async (data) => {
  const options: object = {
    url: `/Api/RefTask/DeleteRefTask`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  if (response !== 0) {
    mdaeNotfy({ message: data.name + " Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_REF_TASK, service, mock);
